import {Input, Select, Text} from '@chakra-ui/react'

const AppointmentSelect = ({DateOnChange, TimeOnChange, errors}) => {
  return (
    <>
      <Text fontWeight={"600"} pl={2} pt={2} pb={1}>Tarih</Text>
      <Input
        onChange={DateOnChange}
        type='date'/>
      {errors.appointment_date && errors.appointment_date.map((e) => <Text key={e} color="red">{e}</Text>)}
      <Text fontWeight={"600"} pl={2} pt={2} pb={1}>Saat aralığı</Text>
      <Select
        onChange={TimeOnChange}
      >
        <option value={""}>Saat aralığı seçiniz</option>
        <option value={"09:00-11:00"}>09:00-11:00</option>
        <option value={"11:00-13:00"}>11:00-13:00</option>
        <option value={"13:00-15:00"}>13:00-15:00</option>
        <option value={"15:00-17:00"}>15:00-17:00</option>
        <option value={"17:00-19:00"}>17:00-19:00</option>
        <option value={"19:00-21:00"}>19:00-21:00</option>
      </Select>
      {errors.appointment_start_time && errors.appointment_start_time.map((e) => <Text key={e} color="red">{e}</Text>)}
    </>
  )
}

export default AppointmentSelect;
